<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">Add Authorized User</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-alert :value="true" color="info" icon="info" outline class="header-intro">
                            By adding a Face AI user, you grant them access to the Face AI website.
                        </v-alert> 
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="userId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Select user"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" style="color:white">Save</v-btn>
                <v-btn @click="clearForm" :disabled="disabled" >Clear</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import faceaiApi from '@/api/faceai'
import employeeApi from '@/api/employees'

export default {
    data () {
        return {
            loading: false,
            disabled: false,
            rules: {
                required: value => !!value || 'Required field.',
            }, 
            error: false,
            errorMessage: null,
            loading_employees: false,
            employees: [],
            existing_users: [],
            userId: null
        }
    },
    methods: {
        setData(data) {
            this.clearForm()
            this.existing_users = data
            this.getEmployees()
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAll()
                if (response && response.status == 200) {
                    //exclude those already exist
                    const filtered = response.data.employees.filter(user => {
                        return !this.existing_users.some(x => x.user.userId == user.userId) 
                    })
                    const teams = [...new Set(filtered.map(x => x.team))];
                    if (teams && teams.length) {
                        teams.forEach(t => {
                            this.employees.push({ header: t })
                            const members = filtered.filter(x => x.team == t)
                            members.forEach(item => {
                                this.employees.push({
                                    userId: item.userId,
                                    name: item.firstName + " " + item.lastName,
                                    avatar: item.avatar,
                                    group: item.team
                                })
                            })
                        })
                    }
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        user: {
                            userId: this.userId
                        }
                    }
                    const response = await faceaiApi.addAuthorizedUsers(data)
                    if (response.status == 200) {
                        this.$emit('send', null)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddUser', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
    },
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 15px 0px 15px;
}
</style>